"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var componentStyle = {
    base: {
        fontWeight: 100,
    },
};
var getStyle = function (style) { return Object.assign({}, componentStyle.base, style); };
exports.Paragraph = function (_a) {
    var children = _a.children, style = _a.style, otherProps = __rest(_a, ["children", "style"]);
    return (React.createElement("p", __assign({ style: getStyle(style) }, otherProps), children));
};
exports.Paragraph.displayName = 'Paragraph';



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Paragraph/Paragraph.tsx
// module id = 622
// module chunks = 0